import React from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Segment, Button, Icon } from 'semantic-ui-react';

import $ from 'jquery';
import Load from '../load';
import Server from '../functions/server';

const grid = 8;

export default class Products extends React.Component {

  state = {products: [], isChanged: false}

  componentDidUpdate(props) {
    if (props.category !== this.props.category) {
      this.getProducts();
    }
  }

  processProducts = (data) => {
    for (var i = 0; i < data.length; i++) {
      data[i].product_category_id = (i + 1) + "";
    }
    return data;
  }

  getProducts = () => {
    let context = this;
    let url = Server() + '/categories/getproductsbycategory.php';
    let data = {id: this.props.data.id, category: this.props.category};
    $.ajax({url, data, method: 'POST', beforeSend: () => {
        context.setState({ load: true });
      }, success: (data) => {
        try {
          data = JSON.parse(data);
          let products = this.processProducts(data);
          this.setState({products: data});
        } catch (e) { alert("Failed"); console.log(data); }
        this.setState({load: false});
      }, error: (e) => {
        alert("Error"); console.log(e);
        this.setState({load: false});
      }});
  }

  getItemStyle = (isDragging, draggableStyle) => {
    let style = {
      userSelect: "none", padding: grid * 2, margin: '0 0 ${grid}px 0',
      background: isDragging ? "lightgreen" : "grey", ...draggableStyle
    }
    return style;
  }

  getListStyle = (isDraggingOver) => {
    return {
      background: isDraggingOver ? "lightblue" : "lightgrey", padding: grid, width: '100%'
    };
  }

  reorder = (list, startIndex, endIndex) => {
    let result = Array.from(list);
    let [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    for (var i = 0; i < result.length; i++) {
      result[i].new_id = (i + 1);
    }
    return result;
  }

  onDragEnd = (result) => {
    if (!result.destination) return ;
    let products = this.reorder(this.state.products, result.source.index, result.destination.index);
    this.setState({ products, isChanged: true });
  }

  save = () => {
    let context = this;
    let url = Server() + '/categories/saveproducts.php';
    let data = {id: this.props.data.id, products: this.state.products };
    $.ajax({url, data, method: 'POST', beforeSend: () => {
        context.setState({ load: true });
      }, success: (data) => {
        try {
          if (data === "1" || data === "true") {
            this.setState({isChanged: false, load: false});
            alert("Success"); return ;
          }
          throw data;
        } catch (e) { alert("Failed"); console.log(data); }
        this.setState({load: false});
      }, error: (e) => {
        alert("Error"); console.log(e);
        this.setState({load: false});
    }});
  }

  render() {
    if (!this.props.category || this.props.category.trim().length < 1) {
      return (<div></div>);
    }
    let save = (
      <center>
        <Button icon labelPosition='left' onClick={this.save} color="green" style={{margin: 10}}>
          <Icon name='save' />
          Save Changes
        </Button>
      </center>
    );
    return (
      <div style={{marginTop: 20}}>
        {this.state.isChanged && save}
        <Load open={this.state.load} message='Getting Products' />
        <DragDropContext onDragEnd={this.onDragEnd}>
          <Droppable droppableId="droppable">
            {(provided, snapshot) => (
              <div {...provided.droppableProps} ref={provided.innerRef} style={this.getListStyle(snapshot.isDraggingOver)}>
                {this.state.products.map((item, index) => (
                  <Draggable key={item.product_category_id} draggableId={item.product_category_id} index={index}>
                      {(provided, snapshot) => (
                        <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}
                          style={this.getItemStyle(snapshot.isDragging, provided.draggableProps.style)}>
                          <Segment clearing>
                            {item.product_name}
                          </Segment>
                        </div>
                      )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    );
  }

}
